<script setup lang="ts">
  import { computed } from "vue";
  import { IconArrowLeft, Tabs, IconChevronRight, Text } from "@ui-kit";
  import { TopBar, StatusBar } from "@src/components";
  import { type ShopZoneWithChildren } from "./useProductZoning";

  const { shopDepartmentList, selectedShopZone } = defineProps<{
    shopDepartmentList: ShopZoneWithChildren[];
    selectedShopZone: ShopZoneWithChildren | null;
  }>();
  const emit = defineEmits<{
    "click:back": [value: void];
    "click:zone": [value: ShopZoneWithChildren];
  }>();

  const tabs = computed(() => shopDepartmentList.map((item) => ({ title: item.title, value: item?.zone_id })));

  const sortedZones = computed(() => {
    return (
      selectedShopZone?.children?.slice().sort((a, b) => {
        return a.title.localeCompare(b.title);
      }) || []
    );
  });
</script>

<template>
  <div class="product-zoning-list" data-testid="product-zoning-list">
    <StatusBar />
    <TopBar title="Зонирование товара" @click:left="() => emit('click:back')" data-testid="top-bar-zoning">
      <template #left>
        <IconArrowLeft />
      </template>
    </TopBar>
    <div data-testid="product-zoning-tabs">
      <Tabs
        bottomLine
        :items="tabs"
        :activeTab="selectedShopZone?.zone_id || ''"
        @changeTab="
          emit(
            'click:zone',
            shopDepartmentList.find((item) => item?.zone_id === $event)
          )
        "
      />
    </div>
    <div class="product-zoning-list__content">
      <div
        v-for="zone in sortedZones"
        :key="zone?.zone_id"
        class="product-zoning-list__content-item"
        @click="() => emit('click:zone', zone)"
        data-testid="product-zoning-list-item"
      >
        <div class="product-zoning-list__content-item-text">
          <Text font="body-medium-16">{{ zone.title }}</Text>
        </div>
        <IconChevronRight />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .product-zoning-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }

  .product-zoning-list :deep(.tabs .tab) {
    flex: 1;
  }

  .product-zoning-list__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 8px;
    padding: 16px;
    overflow-y: auto;
  }

  .product-zoning-list__content-item {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);
  }
</style>
